import React, { useState, useEffect, memo } from 'react';
import CustomInput from '../components/common/CustomInput';
import { useDispatch, useSelector } from 'react-redux';
import { MyInvitesActions } from '../_store/MyInvites.slice';
import MyInvitesSchema from '../validation/MyInvitesSchema';
import { v4 as uuidv4 } from 'uuid';
import { encryptData, handleEncode } from '../utils/encryptDecrypt';
import CustomKeyboard from '../components/common/CustomKeyboard';
import Table from '../components/common/CustomTable';
import Button from '../components/common/ui/Button';
import RadioInput from '../components/common/ui/Inputs/RadioInput'
import SelectInput from '../components/common/ui/Inputs/SelectInput';
import Loader from '../components/common/Loader';
import CustomModal from '../components/common/CustomModal ';
import TranslateFile from '../Loc/TranslateFile';
import useKioskRestrictIntervalValidation from '../hooks/useKioskRestrictIntervalValidation';
import { getStoredValue } from "../../src/_helpers/storageHelper";

const MyInvites = () => {
    const currentLang = TranslateFile();
    const { loginResponse, loginDetails } = useSelector(state => state.kioskLogin);
    const { InviteGridDetails, InvitePublicCountDetails, InsertInmateInvitePublicUserResponse } = useSelector(state => state.MyInvites);
    const storedloginResponse = loginResponse || getStoredValue("loginResponse");
    const storedLoginDetails = getStoredValue("loginDetails") || loginDetails;
    const dispatch = useDispatch();
    const [isInvite, setIsInvite] = useState(false);
    const [errorMessage, setErrorMessage] = useState({});
    const [contactMethod, setContactMethod] = useState("Mobile");
    const [ishandleInvite, setishandleInvite] = useState(false);
    const newGuid = uuidv4();
    const [values, setValues] = useState({});
    const [currentField, setCurrentField] = useState('');
    const [showBoard, setShowBoard] = useState(false);
    const [inputs, setInputs] = useState({ inviteEmail: '', invitePhone: '', inviteFirstName: '', invitelastName: '', inviterelationShip: '', });
    const allFields = ['inviteEmail', 'invitePhone', 'inviteFirstName', 'invitelastName', "inviterelationShip"];
    const placeholder = {
        inviteEmail: currentLang?.MyInvites?.Email_Placeholder, invitePhone: currentLang?.MyInvites?.Mobile_Placeholder,
        inviteFirstName: currentLang?.MyInvites?.FirstName_Placeholder, invitelastName: currentLang?.MyInvites?.LastName_Placeholder,
        inviterelationShip: currentLang?.MyInvites?.Relation_Placeholder
    }
    const [fields, setFields] = useState(allFields);
    const [loading, setLoading] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");
    const [modalContentColor, setmodalContentColor] = useState('#c8605e');
    const isPageReloading = useSelector((state) => state.auth?.isPageReload);
    const validateKioskRestrictInterval = useKioskRestrictIntervalValidation();


    useEffect(() => {
        if (InsertInmateInvitePublicUserResponse?.IsSucceed && ishandleInvite) {
            switch (InsertInmateInvitePublicUserResponse?.IsSucceed) {
                case 1:
                    setPopupMessage(currentLang?.AlertPopup?.Invite_Sent_Successfully);
                    setShowPopup(true); setmodalContentColor('#4a9a93')
                    break;
                case -1:
                    setPopupMessage(currentLang?.AlertPopup?.Operation_Failed);
                    setShowPopup(true); setmodalContentColor('#c8605e')
                    break;
                case -2:
                    const available = InsertInmateInvitePublicUserResponse?.AvailableInviteCount;
                    setPopupMessage(`${currentLang?.AlertPopup?.Public_Invite_Limit} ${available} ${currentLang?.AlertPopup?.Per_Month}`);
                    setShowPopup(true); setmodalContentColor('#c8605e')
                    break;
                case -3:
                    setPopupMessage(contactMethod == "Mobile" ? currentLang?.AlertPopup?.Blocked_Number : currentLang?.AlertPopup?.Blocked_Email);
                    setShowPopup(true); setmodalContentColor('#c8605e')
                    break;
                case -4:
                    setPopupMessage(currentLang?.AlertPopup?.Invalid_Facility_ID);
                    setShowPopup(true); setmodalContentColor('#c8605e')
                    break;
            }
            setContactMethod("Mobile");
            setishandleInvite(false); handleOk();
        }
    }, [InsertInmateInvitePublicUserResponse, ishandleInvite]);

    useEffect(() => {
        if (contactMethod === "Mobile") {
            setFields(allFields.filter(field => field !== "inviteEmail"));
        } else if (contactMethod === "email") {
            setFields(allFields.filter(field => field !== "invitePhone"));
        } else {
            setFields(allFields);
        }
    }, [contactMethod]);

    const MyInviteOptions = [
        { value: "Mobile", label: currentLang?.MyInvites?.Mobile },
        { value: "email", label: currentLang?.MyInvites?.Email },
    ];

    useEffect(() => {
        setIsInvite(false)
        if (storedloginResponse?.FacilityCode) {
            setLoading(InviteGridDetails?.length > 0 ? false : true);
            dispatch(MyInvitesActions.getInmateInvitePUGrid(storedloginResponse)).then(x => {
                setLoading(false);
            });
            dispatch(MyInvitesActions.getLoadInmateInvitePublicCount(storedloginResponse));
        }
    }, [isPageReloading]);

    const handleInvite = async (event) => {
        event.preventDefault();
        setErrorMessage({});
        const { error } = MyInvitesSchema(inputs);
        if (error) {
            const newErrors = {};
            error.details.forEach((e) => {
                if (contactMethod === "Mobile" ? e.message !== currentLang?.ValidationSchema?.Email_Required : e.message !== currentLang?.ValidationSchema?.Mobile_Required) {
                    newErrors[e.path.toString()] = e.message;
                }
            });
            if (Object.keys(newErrors).length > 0) {
                setErrorMessage(newErrors);
                return;
            }
        }

        const InviteUrl = "https://www.inmateinbox.com/";

        var IsNewURL = InvitePublicCountDetails?.[0]?.ISNEWURL

        // const InviteUrl = IsNewURL == 0 ? process.env.REACT_APP_INVITE_WEBSITEURL_OLD : process.env.REACT_APP_INVITE_WEBSITEURL ;
        var MessageContentEmail = `${storedloginResponse.InmateFullName} - (${storedloginResponse.InmatesResdId}) at ${storedLoginDetails.FacilityName} would like to connect at <a href="${InviteUrl}" target="_blank" style="color:blue">https://inmateinbox.com/</a> Visit website for more info.`;

        var bodyNewApp = `${process.env.REACT_APP_WEBSITEURL}` + "InviteLink=" + encodeURIComponent(encryptData(storedloginResponse?.InmateID + "&" + newGuid));
        var bodyOldApp = `${process.env.REACT_APP_WEBSITEURL_OLD}` + "InviteLink=" + handleEncode(storedloginResponse?.InmateID + "&" + newGuid);
        var body = IsNewURL == 0 ? bodyOldApp : bodyNewApp;

        const linkbody = IsNewURL == 0 ? process.env.REACT_APP_WEBSITEURL_OLD : process.env.REACT_APP_WEBSITEURL;


        const MessageContent =
            `Hi,\n\n` +
            `You are receiving this message because you have a connection request from ` +
            `${storedloginResponse.InmateFullName} - ${storedloginResponse.InmatesResdId} at ${storedLoginDetails.FacilityName} ` +
            `through Inmate Inbox application.\n\n` +
            `Inmate Inbox is a new, innovative, and easy-to-use method of sending & receiving secure messages online with inmates. ` +
            `It's fast, secure, and free to sign up.\n\n` +
            `To connect with your contact, click the 'Find Inmates' tab after creating or signing up for an account on ` +
            `${linkbody}\n\n` +
            `To learn more about our program, reply 'HELP'. To stop receiving messages, reply 'STOP'. Carrier charges may apply.\n\n` +
            `Regards,\nInmate Inbox Application. `;



        if (inputs.inviteFirstName && inputs.invitelastName && inputs.inviterelationShip && (inputs.inviteEmail || inputs.invitePhone)) {
            const insertInviteObject = {
                inviteGUID: newGuid,
                inmatesId: storedloginResponse?.InmateID,
                facilityID: storedloginResponse?.facilityID,
                inviteThrough: contactMethod == "email" ? "Email" : contactMethod,
                isPhoneNumber: contactMethod == "email" ? false : true,
                message: contactMethod == "email" ? MessageContentEmail : MessageContent,
                contactNumberOrEmail: contactMethod == "email" ? inputs.inviteEmail : ('+1' + inputs.invitePhone),
                isSucceed: 0, returnID: 0, sendInviteStatus: "Sent", inviteBody: contactMethod == "email" ? body : MessageContent,
                firstName: inputs.inviteFirstName,
                lastName: inputs.invitelastName, PodCode: storedLoginDetails?.PodCode, InviteSendReturnID: '',
                relationShip: inputs.inviterelationShip,
            };
            dispatch(MyInvitesActions.InsertInmateInvitePublicUser(insertInviteObject));
            setishandleInvite(true); setErrorMessage({});
        }
    };

    const columns = [
        {
            name: currentLang?.TableHeaders?.Date, width: '150px', selector: (row) => row.InviteSentDate, sortable: true,
            cell: (row) => (
                <div className="d-flex font-size-12 fw-500" >
                    {row.InviteSentDate}
                </div>
            ),
            sortFunction: (a, b) => new Date(a.InviteSentDate) - new Date(b.InviteSentDate),
        },
        {
            name: currentLang?.TableHeaders?.Contact_Mode, width: '130px', selector: (row) => row.InviteThrough, sortable: true,
            sortFunction: (a, b) => a.InviteThrough.toLowerCase().localeCompare(b.InviteThrough.toLowerCase())
        },
        {
            name: currentLang?.TableHeaders?.First_Name, selector: (row) => row.FirstName, sortable: true,
            sortFunction: (a, b) => a.FirstName.toLowerCase().localeCompare(b.FirstName.toLowerCase())
        },
        {
            name: currentLang?.TableHeaders?.Last_Name, selector: (row) => row.LastName, sortable: true,
            sortFunction: (a, b) => a.LastName.toLowerCase().localeCompare(b.LastName.toLowerCase())
        },
        {
            name: currentLang?.TableHeaders?.Number_Email, width: '250px', selector: (row) => row.ContactNumberOrEmail, sortable: true, sortable: true,
            cell: (row) => (
                <div className="d-flex " >
                    {row.ContactNumberOrEmail}
                </div>
            ),
            sortFunction: (a, b) => a.ContactNumberOrEmail.toLowerCase().localeCompare(b.ContactNumberOrEmail.toLowerCase())
        },
        {
            name: currentLang?.TableHeaders?.Relation, width: '', selector: (row) => row.RelationshipStatus, sortable: true,
            sortFunction: (a, b) => a.RelationshipStatus.toLowerCase().localeCompare(b.RelationshipStatus.toLowerCase())
        },
        {
            name: currentLang?.TableHeaders?.Status, selector: (row) => row.SendInviteStatus, sortable: true,
            sortFunction: (a, b) => a.SendInviteStatus.toLowerCase().localeCompare(b.SendInviteStatus.toLowerCase()),
            cell: (row) => (
                <div className="d-flex " title={SendInviteStatus(row.SendInviteStatus)} >
                    {SendInviteStatus(row.SendInviteStatus, true)}
                </div>
            ),
        },
    ];
    const SendInviteStatus = (status, isclassName = false) => {
        const statusClasses = {
            sent: "StatusSent",
            undelivered: 'StatusPatch-danger',
            delivered: "StatusSent",
            queued: "Statusqueued",
            failed: 'StatusPatch-danger',
        };
        return isclassName ? <span className={statusClasses[status?.toLowerCase()]}>{status}</span> : status;
    };

    const handleOk = async () => {
        setIsInvite(false); setishandleInvite(false);
        dispatch(MyInvitesActions.getInmateInvitePUGrid(storedloginResponse));
        dispatch(MyInvitesActions.getLoadInmateInvitePublicCount(storedloginResponse));
        setInputs({ inviteEmail: '', invitePhone: '', inviteFirstName: '', invitelastName: '', inviterelationShip: '', });
    }

    const handleFieldClick = (field) => {
        let data = inputs ? { invitePhone: inputs.invitePhone || '', inviteEmail: inputs.inviteEmail || '', inviteFirstName: inputs.inviteFirstName || '', invitelastName: inputs.invitelastName || '', inviterelationShip: inputs.inviterelationShip || '' }
            : { invitePhone: '', inviteEmail: '', inviteFirstName: '', invitelastName: '', inviterelationShip: '' };
        setValues(data)
        setCurrentField(field);
        setShowBoard(true); // Show the keyboard when a field is clicked
    };

    const handleCancel = () => {
        if (values.invitePhone || values.inviteEmail || values.inviteFirstName || values.invitelastName || values.inviterelationShip) {
            setInputs(values);
        } else {
            // Reset LoginId and Pin if no values are available
            setInputs({ inviteEmail: '', invitePhone: '', inviteFirstName: '', invitelastName: '', inviterelationShip: '', });
        }
        setShowBoard(false)
    }

    useEffect(() => {
        validateKioskRestrictInterval(storedLoginDetails)
    }, []);


    return (
        <div className="dashboard-container">
            <div className="dashboard-content">

                <div className="d-flex justify-content-between mb-1 pt-1">
                    <div className="align-self-start">
                        <div className="icon-container">
                            <h3 className="find-inmate-head">{currentLang?.MyInvites?.My_Invites}</h3>
                        </div>
                    </div>
                    <div>
                        {isInvite ? (
                            <Button label={currentLang?.Buttons?.Back} type="button" className='btn btn-danger' status="back" onClick={() => { setIsInvite(false); setContactMethod("Mobile"); setErrorMessage({}); setInputs({ inviteEmail: '', invitePhone: '', inviteFirstName: '', invitelastName: '', inviterelationShip: '', }) }} />
                        ) : (
                            (InvitePublicCountDetails?.[0]?.InmateSentInvitePublicCount < InvitePublicCountDetails?.[0]?.InmateInvitePublicLimit) && (
                                <Button
                                    variant="success"
                                    onClick={() => setIsInvite(true)}
                                    label={currentLang?.Buttons?.Invite_Now}
                                    type="button"
                                    className='btn btn-danger'
                                    status="success"
                                    disabled={false}
                                />
                            )
                        )}
                    </div>
                </div>
                <div className="divider mb-3"></div>
                <h2 className="subtitle msg-cost">{currentLang?.MyInvites?.Available_Invites} {InvitePublicCountDetails?.[0]?.InmateAvailbleCount || 0}</h2>
                <div className="card-default">
                    {!isInvite ? (
                        (InviteGridDetails?.length > 0 ?
                            <Table
                                isScrollContainer={true}
                                columns={columns}
                                data={InviteGridDetails}
                                pagination
                                handleONCLick={() => { }}
                                totalRowCount={InviteGridDetails?.length}
                                currentPage={1}
                                paginationPerPage={10}
                                maxHeight={'530px'}
                            />
                            :
                            (!loading && <span className="col-no-data">{currentLang?.No_Data_Found}</span>)
                        )
                    ) : (
                        <div >

                            <div className="actions">
                                <RadioInput
                                    name="ActiveStatus"
                                    label=''
                                    options={MyInviteOptions}
                                    selectedValue={contactMethod}
                                    handleChange={(e) => { setContactMethod(e.target.value); setErrorMessage({}); setInputs({ inviteEmail: '', invitePhone: '', inviteFirstName: '', invitelastName: '', inviterelationShip: '', }) }}
                                />
                            </div>
                            <form onSubmit={handleInvite}>
                                <div className="row">
                                    {contactMethod !== "email" ? <>
                                        <div className="col-lg-6">
                                            <label className='form-label col-form-label  w-100 fs-5 form-label-custom-visible'>{currentLang?.MyInvites?.Mobile_Label} <span className='mandatory'>*</span></label>
                                            <div className="row">
                                                <div className="col-xs-3 col-sm-3 col-md-3 col-lg-3">
                                                    <div className='mt-1'>
                                                        <SelectInput
                                                            options={[]}
                                                            required={true}
                                                            value="US (+1)"
                                                            isDisabled={true}
                                                            placeholder="US (+1)"
                                                        />
                                                    </div>
                                                </div>

                                                <div className={contactMethod !== "email" ? "col-xs-9 col-sm-9 col-md-9 col-lg-9" : "col-lg-9 col-md-9"}>
                                                    <div className='mt-1'>
                                                        <CustomInput
                                                            type={"tel"}
                                                            id="inputValue"
                                                            value={inputs.invitePhone}
                                                            placeholder={currentLang?.MyInvites?.Mobile_Placeholder}
                                                            onClick={() => handleFieldClick('invitePhone')}
                                                            errorMessage={errorMessage.invitePhone}
                                                            maxLength={10}
                                                            required={true}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </>
                                        :
                                        <div className="col-lg-6 mt-1">
                                            <CustomInput
                                                label={currentLang?.MyInvites?.Email_Label}
                                                type={"text"}
                                                id="inputValue"
                                                value={inputs.inviteEmail}
                                                placeholder={currentLang?.MyInvites?.Email_Placeholder}
                                                onClick={() => handleFieldClick('inviteEmail')}
                                                errorMessage={errorMessage.inviteEmail}
                                                required={true}
                                            /></div>
                                    }
                                    <div className="col-lg-6 mt-1">
                                        <CustomInput
                                            label={currentLang?.MyInvites?.FirstName_Label}
                                            type="text"
                                            placeholder={currentLang?.MyInvites?.FirstName_Placeholder}
                                            id="inviteFirstName"
                                            value={inputs.inviteFirstName}
                                            onClick={() => handleFieldClick('inviteFirstName')}
                                            errorMessage={errorMessage.inviteFirstName}
                                            required={true}
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-lg-6 mt-1">
                                        <CustomInput
                                            label={currentLang?.MyInvites?.LastName_label}
                                            type="text"
                                            placeholder={currentLang?.MyInvites?.LastName_Placeholder}
                                            id="invitelastName"
                                            value={inputs.invitelastName}
                                            onClick={() => handleFieldClick('invitelastName')}
                                            errorMessage={errorMessage.invitelastName}
                                            required={true}
                                        /></div>
                                    <div className="col-lg-6 mt-1">
                                        <CustomInput
                                            label={currentLang?.MyInvites?.Relation_Label}
                                            type="text"
                                            id="inviterelationShip"
                                            placeholder={currentLang?.MyInvites?.Relation_Placeholder}
                                            value={inputs.inviterelationShip}
                                            onClick={() => handleFieldClick('inviterelationShip')}
                                            errorMessage={errorMessage.inviterelationShip}
                                            required={true}
                                        /></div>
                                </div>
                                <div className="d-flex justify-content-center mt-2">
                                    <Button
                                        variant="success"
                                        onClick={handleInvite}
                                        label={currentLang?.Buttons?.Invite}
                                        type="button"
                                        status="success"
                                        disabled={ishandleInvite}
                                        isLoading={ishandleInvite}
                                    />
                                </div>
                            </form>
                            {showBoard && (
                                <CustomKeyboard
                                    currentField={currentField}
                                    setCurrentField={setCurrentField}
                                    inputs={inputs}
                                    setShowBoard={setShowBoard}
                                    handleCancel={handleCancel}
                                    setInputs={setInputs}
                                    fields={fields}
                                    setErrorMessage={setErrorMessage}
                                    type="Multiple"
                                    isTabfunction={false}
                                    setValues={setValues}
                                    placeholderList={placeholder} />
                            )}
                        </div>
                    )}
                </div>
                {(loading || ishandleInvite) && <Loader isinvite={ishandleInvite} />}
            </div>

            {showPopup && (
                <CustomModal
                    color={modalContentColor}
                    content={popupMessage}
                    onOkClick={() => { setShowPopup(false); }}
                />
            )}
        </div>
    );
};

export default memo(MyInvites);
